import { useState } from 'react';
import { supabase } from '../../lib/supabaseClient.ts';
import MapComponent from '../MapComponent';
import ContactAddress from './ContactAddress';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    hide_email: false,
  });

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id === 'checkbox' ? 'hide_email' : id]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { error } = await supabase
      .from('contacts')
      .insert([formData]);

    if (error) {
      console.error(error);
      alert('❌ Erreur lors de l\'envoi du message.');
    } else {
      alert('✅ Message envoyé avec succès !');
      setFormData({ name: '', email: '', message: '', hide_email: false });
    }
  };

  return (
    <section className="contact-area pt-110 pb-110">
      <div className="container">
        <div className="container-inner-wrap">
          <div className="row justify-content-center justify-content-lg-between">
            <div className="col-lg-6 col-md-8 order-2 order-lg-0">
              <div className="contact-title mb-20">
                <h5 className="sub-title">Contactez-nous</h5>
                <h2 className="title">Parlons ensemble<span>.</span></h2>
              </div>
              <div className="contact-wrap-content">
                <p>Animalia Plus est là pour répondre à toutes vos questions concernant nos produits pour chiens et chats. N’hésitez pas à nous contacter !</p>
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-grp">
                    <label htmlFor="name">Votre Nom <span>*</span></label>
                    <input type="text" id="name" value={formData.name} onChange={handleChange} placeholder="Jean Dupont..." required />
                  </div>
                  <div className="form-grp">
                    <label htmlFor="email">Votre Email <span>*</span></label>
                    <input type="email" id="email" value={formData.email} onChange={handleChange} placeholder="exemple@email.com" required />
                  </div>
                  <div className="form-grp">
                    <label htmlFor="message">Votre Message <span>*</span></label>
                    <textarea id="message" value={formData.message} onChange={handleChange} placeholder="Votre opinion..." required />
                  </div>
                  <div className="form-grp checkbox-grp">
                    <input type="checkbox" id="checkbox" checked={formData.hide_email} onChange={handleChange} />
                    <label htmlFor="checkbox">Ne pas afficher votre adresse email</label>
                  </div>
                  <button type="submit" className="btn rounded-btn">Envoyer</button>
                </form>
              </div>
            </div>

            <ContactAddress/>
          </div>
        </div>
        <br />
        <MapComponent />
      </div>
    </section>
  );
}

export default ContactForm;
